import { Component, ViewChild } from '@angular/core';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/shared/services/auth.service';
import { ApiCredentialsService } from './api-credentials.service';
import { TableApiCredentials } from '../table-api-credentials/table-api-credentials.component';

@Component({
  selector: 'app-api-credentials',
  templateUrl: './api-credentials.component.html',
  styleUrls: ['./api-credentials.component.scss'],
})
export class ApiCredentialsComponent {
  aReceber: number = 0;
  recebimento: number = 0;
  ticketMedioRecebimento: number = 0;
  conversao: number = 0;
  saque: number = 0;
  saquePendente: number = 0;
  saldoFinal: number = 0;

  extrato = new FormGroup({
    tipo: new FormControl<string>(''),
    status: new FormControl<string>(''),
    tipoBusca: new FormControl<string>(''),
    origem: new FormControl<string>(''),
    aplicacao: new FormControl<string>(''),
    valorFiltro: new FormControl<string>(''),
    initialDate: new FormControl<NgbDateStruct | null>(
      null,
      Validators.required
    ),
    endDate: new FormControl<NgbDateStruct | null>(null, Validators.required),
  });

  transactionTypes = [
    { name: 'common.general', value: '' },
    { name: 'common.deposit', value: 'DEPOSITO' },
    { name: 'common.withdraw', value: 'SAQUE' },
  ];
  statusList: any[] = [
    { name: 'Todos', value: '' },
    { name: 'Pendente', value: 'PENDENTE' },
    { name: 'Realizado', value: 'REALIZADO' },
    { name: 'Analise', value: 'ANALISE' },
  ];
  // originList: { name: string; value: string }[] = [];
  originList = [
    { name: 'Todos', value: '' },
    { name: 'Pix', value: 'PIX' },
    { name: 'Comissão', value: 'COMISSÃO' },
    { name: 'Cripto', value: 'CRIPTO' },
    { name: 'Taxa Bancária', value: 'TAXA BANCÁRIA' },
    { name: 'Reembolso', value: 'REEMBOLSO' },
    { name: 'Tef', value: 'TEF' }
  ];

  applicationList = [
    { name: 'Todos', value: '' },
    { name: 'common.web', value: 'WEB' },
    { name: 'common.api', value: 'API' }
  ];
  tipoBuscaList: any[] = [
    { name: 'common.description', value: 'personName' },
    { name: 'common.id', value: 'id' },
    { name: 'common.idempotencyKey', value: 'idempotencyKey' },
    { name: 'common.document', value: 'cpf' },
  ];

  originMap: any = {
    BRL: { flag: 'assets/flags/4x3/br.svg', gmtOffset: -3, name: 'Brasil' },
    MXN: { flag: 'assets/flags/4x3/mx.svg', gmtOffset: -6, name: 'México' },
    CLP: { flag: 'assets/flags/4x3/cl.svg', gmtOffset: -4, name: 'Chile' },
    PEN: { flag: 'assets/flags/4x3/pe.svg', gmtOffset: -5, name: 'Peru' },
    COP: { flag: 'assets/flags/4x3/co.svg', gmtOffset: -5, name: 'Colômbia' },
    PHP: { flag: 'assets/flags/4x3/ph.svg', gmtOffset: +8, name: 'Philippines' }
  };

  public accountOrigin: any;
  public isFilterColapsed = false;
  public isSubmitted = false;
  public isLoaded: boolean = false;
  public accountMultiDash: any;

  @ViewChild(TableApiCredentials) table!: TableApiCredentials;

  constructor(
    private apiCredentialsService: ApiCredentialsService,
    private toastr: ToastrService
  ) {
    const currentDate = new Date();
    currentDate.setDate(currentDate.getDate());
    this.extrato.controls.initialDate.setValue({
      year: currentDate.getFullYear(),
      month: currentDate.getMonth() + 1,
      day: currentDate.getDate(),
    });
    this.extrato.controls.endDate.setValue({
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
      day: new Date().getDate(),
    });
    this.extrato.controls.status.setValue('REALIZADO');
    this.extrato.controls.tipoBusca.setValue('personName')
    this.loadAccountOrigin();

  }

  onTableLoading(isLoading: boolean) {
    this.isLoaded = !isLoading;
  }

  onTableSwitched() {
    this.loadAccountOrigin();
    this.table.page = 1;
    this.table.loadData();
  }


  loadAccountOrigin() {
    this.isLoaded = false;
    this.apiCredentialsService.getAccountOrigin().subscribe({
      next: (res) => this.accountOrigin = res,
      error: () => this.accountOrigin = null
    });
  }

  async copyToClipboard(value: string | null | undefined, label: string) {
    if (!value) {
      this.toastr.error(`Nenhum ${label} disponível para copiar.`, 'Erro', {
        timeOut: 3000,
        positionClass: 'toast-top-right',
      });
      return;
    }

    try {
      await navigator.clipboard.writeText(value);
      this.toastr.success(
        `${label} copiado para a área de transferência.`,
        'Sucesso',
        {
          timeOut: 3000,
          positionClass: 'toast-top-right',
        }
      );
    } catch (err) {
      console.error('Erro ao copiar para clipboard:', err);
      this.toastr.error(
        'Não foi possível copiar para a área de transferência.',
        'Erro',
        {
          timeOut: 3000,
          positionClass: 'toast-top-right',
        }
      );
    }
  }

}
